import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const callApplicationFileApi = createApi({
  reducerPath: "callApplicationFileApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["CallApplicationFile", "FileCategory"],
  endpoints: (builder) => ({
    getFilesByCallApplicationId: builder.query({
      query: (callApplicationId) => ({
        url: `/call_application_file/${callApplicationId}/files`,
        method: "GET",
      }),
      providesTags: (result, error, callApplicationId) => [
        { type: "CallApplicationFile", id: callApplicationId },
      ],
    }),
    getFileCategories: builder.query({
      query: () => ({
        url: `/call_application_file/categories`,
        method: "GET",
      }),
      providesTags: ["FileCategory"],
    }),
    createFileWithUpload: builder.mutation({
      query: ({ callApplicationId, fileData }) => ({
        url: `/call_application_file/${callApplicationId}/create_with_file`,
        method: "POST",
        body: fileData,
      }),
      invalidatesTags: (result, error, { callApplicationId }) => [
        { type: "CallApplicationFile", id: callApplicationId },
      ],
    }),
    deleteFile: builder.mutation({
      query: ({ fileId }) => ({
        url: `/call_application_file/file/${fileId}`,
        method: "DELETE",
      }),
      // Require the caller to pass callApplicationId so we only invalidate that call's files
      invalidatesTags: (result, error, { callApplicationId }) =>
        callApplicationId
          ? [{ type: "CallApplicationFile", id: callApplicationId }]
          : [{ type: "CallApplicationFile" }],
    }),
  }),
});

export const {
  useGetFilesByCallApplicationIdQuery,
  useGetFileCategoriesQuery,
  useCreateFileWithUploadMutation,
  useDeleteFileMutation,
} = callApplicationFileApi;
